var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.list),function(item,i){return _c('bingo',{key:i,attrs:{"bingo":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }